import React, { Component } from "react"
import { connect } from "react-redux"
import { TableHeaderColumn } from "react-bootstrap-table"
import "react-bootstrap-table/dist/react-bootstrap-table.min.css"
import { Image } from "react-bootstrap"
import { DckActionCreators, DckSelectors } from "dck-redux"

import * as ItemTypes from "../../redux/items/types"
import { browserHistory, Link } from "react-router"
import PropTypes from "prop-types"
import BundleTable from "./BundleTable"
import FontAwesome from "react-fontawesome"
import Authenticated from "../../lib/Authenticated"
import { BooleanStatuses, selectFiltersFromStore, sortNumber } from "../../lib/utils"
import ClearFiltersButton from "../fragments/ClearFiltersButton"

class ListBundles extends Component {

  authenticated = new Authenticated()
  isAdmin = this.authenticated.isAdmin()
  isAccountant = this.authenticated.isAccountant()
  canEditBundle = this.isAdmin || this.isAccountant

  static renderItemToRemove = item => `${item.id} : ${item.name}`

  componentDidMount() {
    this.props.loadBundles()
  }

  renderUpdateLink = (bundleId, collateralDisabled) => {

    if(!this.canEditBundle) return null

    return collateralDisabled
      ? <FontAwesome name="pencil" size="lg" className="gray" 
        title='Cannot be updated. Collateral has been removed!' />
      : <Link to={`/bundles/${bundleId}/update`} className='p-5'>
          <FontAwesome name="pencil" title='Update' />
        </Link>
  }

  doClearFilters = () => {
    this.refs.name.cleanFiltered()
    this.refs.shortName.cleanFiltered()
    this.refs.amount.cleanFiltered()
    this.refs.purchaseAmount.cleanFiltered()
    this.refs.repayments.cleanFiltered()
    this.refs.collaterals.cleanFiltered()
    this.refs.active.cleanFiltered()
  }

  detailsLink = id => `/bundles/${id}/detail`

  renderDetailLink = (id, content) =>
    <Link to={ this.detailsLink(id) } className="p-5">
      { content }
    </Link>

  render() {
    const { bundles, removeBundle, loadBundles, collateralFilters, setBundle } = this.props
    return (
      <div>

        <ClearFiltersButton onClick={ this.doClearFilters } />

        <BundleTable
          items={ bundles }
          onConfirmRemoval={ removeBundle }
          renderItemToRemove={ ListBundles.renderItemToRemove }
          addNewLabel="New bundle"
          addNewHandler={() => browserHistory.push("/bundles/add")}
          loadBundles={ loadBundles }
          canEditBundle={ this.canEditBundle }
          setBundle={ setBundle }>

          <TableHeaderColumn
            isKey
            dataField="id"
            dataAlign="center"
            tdStyle={{ verticalAlign: "middle" }}
            dataFormat={(_, row) => row.imageId
              ? <Image alt={row.name} src={row.photoUrl} rounded width={48} />
              : <FontAwesome name="suitcase" size="2x" className="bundle-icon" />
            }
            csvHeader="Bundle ID"
            width="80px"
          />

          <TableHeaderColumn
            ref="name"
            dataField="name"
            dataAlign="left"
            tdStyle={{ verticalAlign: "middle" }}
            dataSort
            filter={{ type: "TextFilter", delay: 1000 }}
            dataFormat={(name, { id, active }) =>
              this.renderDetailLink(id, <span className={ !active ? 'red' : ''}>{ name }</span>)}
            csvHeader="Name"
            columnClassName="min-w-120"
          >
            Name
          </TableHeaderColumn>

          <TableHeaderColumn
            ref="shortName"
            dataField="shortName"
            dataAlign="center"
            tdStyle={{ verticalAlign: "middle" }}
            dataSort
            filter={{ type: "TextFilter", delay: 1000 }}
            dataFormat={cell => <span className="gray">{ cell }</span>}
            csvHeader="Short name"
            width="120px"
          >
            Short name
          </TableHeaderColumn>

          <TableHeaderColumn
            ref="amount"
            dataField="amountFormatted"
            dataAlign="right"
            dataSort
            sortFunc={(a, b, order) => sortNumber(a.cost, b.cost, order)}
            tdStyle={{ verticalAlign: "middle" }}
            filter={{ type: "TextFilter", delay: 1000 }}
            csvHeader="Selling price"
            columnClassName="min-w-120"
          >
            Selling price (VAT Incl.)
          </TableHeaderColumn>

          <TableHeaderColumn
            ref="sellingVAT"
            dataField="sellingVAT"
            dataAlign="right"
            dataSort
            sortFunc={(a, b, order) => sortNumber(a.sellingVAT, b.sellingVAT, order)}
            tdStyle={{ verticalAlign: "middle" }}
            dataFormat={sellingVAT => sellingVAT + '%'}
            filter={{ type: "TextFilter", delay: 1000 }}
            csvHeader="VAT on Sales"
            width="110px"
          >
            VAT on Sales
          </TableHeaderColumn>

          <TableHeaderColumn
            ref="purchaseAmount"
            dataField="purchaseAmountFormatted"
            dataAlign="right"
            dataSort
            sortFunc={(a, b, order) => sortNumber(a.purchaseCost, b.purchaseCost, order)}
            tdStyle={{ verticalAlign: "middle" }}
            filter={{ type: "TextFilter", delay: 1000 }}
            csvHeader="Purchase cost"
            columnClassName="min-w-120"
          >
            Purchase cost (VAT Incl.)
          </TableHeaderColumn>

          <TableHeaderColumn
            ref="purchaseVAT"
            dataField="purchaseVAT"
            dataAlign="right"
            dataSort
            sortFunc={(a, b, order) => sortNumber(a.purchaseVAT, b.purchaseVAT, order)}
            tdStyle={{ verticalAlign: "middle" }}
            dataFormat={purchaseVAT => purchaseVAT + '%'}
            filter={{ type: "TextFilter", delay: 1000 }}
            csvHeader="VAT on Purchases"
            width="110px"
          >
            VAT on Purchases
          </TableHeaderColumn>

          <TableHeaderColumn
            ref="repayments"
            dataField="repayments"
            dataAlign="center"
            dataSort
            sortFunc={(a, b, order) => sortNumber(a.numberOfRepayments, b.numberOfRepayments, order)}
            tdStyle={{ verticalAlign: "middle" }}
            filter={{ type: "TextFilter", delay: 1000 }}
            csvHeader="Repayments"
          >
            Repayments
          </TableHeaderColumn>

          <TableHeaderColumn
            ref="collaterals"
            dataField="collaterals"
            dataSort
            tdStyle={{ verticalAlign: "middle" }}
            dataAlign="center"
            dataFormat={(cell, row) => <small
              title={ row.collateralDisabled ? 'Collateral has been removed!' : ''}
              className={ row.collateralDisabled ? "collateralDisabled" : ''}>
              { cell }
            </small>
            }
            filter={{ type: "SelectFilter", options: collateralFilters }}
            csvHeader="Loan collateral"
            columnClassName="min-w-120"
          >
            Loan Collateral
          </TableHeaderColumn>

          <TableHeaderColumn
            ref="active"
            dataField="active"
            dataAlign="center"
            dataSort
            width="90px"
            tdStyle={{ verticalAlign: "middle" }}
            filter={{ type: "SelectFilter", options: BooleanStatuses }}
            csvHeader="Active"
            dataFormat={(active, row) => <FontAwesome
              title={ active ? 'Active' : 'Inactive' } 
              style={{ color: row.collateralDisabled ? 'gray' : (active ? 'green' : '#a66') }} 
              name={ active ? 'check' : 'close' } />
            }>
            Active
          </TableHeaderColumn>

          <TableHeaderColumn
            dataAlign="center"
            width="80px"
            tdStyle={{ verticalAlign: "middle" }}
            dataFormat={(_, { id, collateralDisabled }) => 
            <span className="flex-detail">
              { this.renderDetailLink(id, <FontAwesome name="eye" title='View' />) }
              { this.renderUpdateLink(id, collateralDisabled) }
            </span>}
          />
        </BundleTable>
      </div>
    )
  }
}

ListBundles.propTypes = {
  bundles: PropTypes.array.isRequired,
  loadBundles: PropTypes.func.isRequired,
  removeBundle: PropTypes.func.isRequired
}

const mapStateToProps = state => {

  const bundles = DckSelectors.selectAllItems(state, ItemTypes.Bundle),

  collateralFilters = selectFiltersFromStore(state, ItemTypes.CollateralBundleFilter)

  return { bundles, collateralFilters }
},

mapDispatchToProps = dispatch => ({

  loadBundles: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.Bundle)),

  removeBundle: id => dispatch(DckActionCreators.itemRemove(ItemTypes.Bundle, id)),

  setBundle: (id, data) => dispatch(DckActionCreators.itemSet(ItemTypes.Bundle, id, data)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ListBundles)



// WEBPACK FOOTER //
// ./src/components/Bundles/List.js